import React, { useCallback, useState } from 'react'
import { ValidationBoundary, ValidationState } from '@/components/validation'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import { ConfirmFooter } from '@/dialogs/common/confirmFooter'
import { MessageEditorContent } from '@/components/messages/editor-content'
import { ModalBody } from 'reactstrap'
import context from '@/context'
import { openErrorDialog } from '@/utils/dialogHelpers'

function ComposeNewMessageDialog (props) {
  const [message, setMessage] = useState({})
  const [attachments, setAttachments] = useState([])
  const [saving, setSaving] = useState(false)

  const { onAction, targetInstitution } = props

  const handleAction = useCallback(() => {
    setSaving(true)
    context.api.messagesService.saveMessage({
      ...message,
      institutionId: message.institutionId ? message.institutionId : targetInstitution,
      attachments: attachments.map(x => x.id)
    }).then((id) => onAction({ item: { id, subject: message.subject } }))
      .catch(openErrorDialog)
  }, [attachments, message, onAction, targetInstitution])

  const updateDto = useCallback(data => setMessage({ ...message, ...data }), [message])
  const updateAttachmentsDto = useCallback(data => setAttachments([...attachments, ...data]), [attachments])

  return <ValidationBoundary>
    <BasicHeader title='Messages.CreateMessage' {...props} />
    <ModalBody>
      <MessageEditorContent message={message}
        attachments={attachments}
        updateDto={updateDto}
        updateAttachments={updateAttachmentsDto}
        hideRecipient={!!targetInstitution}
      />
    </ModalBody>
    <ValidationState render={({ isValid }) =>
      <ConfirmFooter {...props} onAction={handleAction} primaryButtonText={'Messages.SaveAsDraft'} disabled={!isValid || saving} icon='save' />}
    />
  </ValidationBoundary>
}

export default {
  component: ComposeNewMessageDialog
}



// WEBPACK FOOTER //
// ./src/dialogs/composeNewMessage.js